import { Box, Grid, TextField } from '@mui/material';
import { ISituacaoEmergencia } from '../../../services/api/action-plan/Pae';
import { useEffect, useState } from 'react';

interface EmergencySituationProps {
    smDown: boolean;
    value: ISituacaoEmergencia | undefined,
    onChange: (data: ISituacaoEmergencia) => void
}

export const EmergencySituation = ({smDown, value, onChange}: EmergencySituationProps) => {

    const [data, setData] = useState<ISituacaoEmergencia>({
        data_atualizacao: '',
        nive_emergencia: ''
    });    

    useEffect(() => {
        if (value) {
            if(value.data_atualizacao){
                const dataFormatada = value.data_atualizacao.split(' ')[0];
                value.data_atualizacao = dataFormatada;
            }
            setData(value);
        }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        const newData = {
            ...data,
            [name]: value,
        };
        setData(newData);
        onChange(newData);
    };

    return(
        <Box flex={1}>
            <Grid container spacing={1}>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Data de atualização'
                        type='date'
                        name='data_atualizacao'
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => handleChange(e)}
                        value={data.data_atualizacao}
                    />
                </Grid>
                <Grid item xs={smDown ? 12 : 6}>
                    <TextField
                        label='Nível de emergência'
                        type='text'
                        name='nive_emergencia'
                        fullWidth
                        onChange={(e) => handleChange(e)}
                        // value={data.nivel_emergencia}
                        value={data.nive_emergencia}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};